import { AxiosError } from 'axios';

export interface AuthState {
  isLogged: boolean;
  loginChecked: boolean;
  redirectUrl: string | null;
  token?: {
    type: string;
    token: string;
    expiresAt: string;
  };
  fullName: string;
  loginEmail: string;
  preferredTimezone: string;
  backOfficeAccess: boolean;
  roles: [
    {
      name: string;
      backOfficeAccess: boolean;
    }
  ];
  permissions: string[];
  customerUuid: string;
  studentUuid: string;
  accountUuid: string;
  sso: boolean;
}

interface AuthApiResponseRoles {
  name: string;
  backOfficeAccess: boolean;
}

export interface PasswordRegisterApiResponse {
  contactEmail: string;
  contactPhone: string;
  name: string;
}

export enum AuthenticationResultCode {
  Success = 0, /// Ok
  InvalidTenant = -1, /// Empresa inválida
  TenantDisabled = -2, /// Empresa desativada
  InvalidLogin = -3, /// Login inválido
  LoginDisabled = -4, /// Login desativado
  LoginLocked = -5, /// Login travado
  InvalidPassword = -6, /// Senha inválida
  PasswordExpired = -7, /// Senha expirada
  CustomerDisabled = -8, /// Consumidor desativado
  StudentDisabled = -9, /// Estudante desativado
  SchoolDisabled = -10, /// Escola desativada
  InvalidRecoveryToken = -11, /// Token de recuperação inválido
  RecoveryTokenExpired = -12, /// Token de recuperação expirado
  InvalidSession = -13, /// Sessão inválida
  InvalidSchool = -15, /// Escola inválida
  TeacherDisabled = -16, /// Professor desativado
  InvalidRefreshToken = -17, /// Token inválido para atualização
  InvalidCustomer = -18, /// Consumidor inválido
  InvalidAccount = -19, /// Conta inválida
  InvalidPasswordPolicyMatch = -20, /// Senha inválida conforme política de segurança
  SamePasswordAsOldPassword = -21, /// Senha inválida conforme política de segurança
  RecoveryTokenWithoutAccount = -22, /// Token de recuperação não em conta de usuário atrelada
  InvalidClientApplication = -23, /// Client Applicaton inválido
  InvalidMFAOTP = -24, /// Invalid MFA OTP
  MFANeedsActivation = -25, /// MFA needs activation
  MFANeedsOTP = -26, /// MFA needs TOTP to continue
  ExternalAuthenticationError = -27, /// ExternalAuthenticationError
  RecoveryRequestNotAllowed = -28, /// RecoveryRequestNotAllowed
  RecoveryByEmailFailed = -29, /// RecoveryByEmailFailed

  InternalError = -99, /// Erro interno
}

export interface AuthenticationApiResponse {
  authenticationResult: AuthenticationResultCode;
  message: string;
}

export interface RegisterApiResponse {
  apiResultData: string;
  apiResultCode: number;
  apiResultMessage: string;
}

export interface AuthApiResponse {
  authenticationResult: number;
  message: string;
  token: {
    type: string;
    token: string;
    expiresAt: string;
  };
  fullName: string;
  loginEmail: string;
  preferredTimezone: string;
  backOfficeAccess: boolean;
  roles: [AuthApiResponseRoles];
  permissions: string[];
  customerUuid: string;
  studentUuid: string;
  accountUuid: string;
  sso: boolean;
}

export interface UseAuthState extends AuthState {
  setAuth: (props: AuthApiResponse) => void;
  clearAuth: () => void;
  setRedirectUrl: (url: string | null) => void;
  authHandlingError: (error: AxiosError, callback: (error: AxiosError) => void) => void;
}
